import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-12 h-12 text-[#C9A84C] mx-auto mb-4" />
            <h2 className="font-display text-2xl text-[#F5F0E8] mb-2">
              Oops, quelque chose a mal tourné
            </h2>
            <p className="text-sm text-[#B9B2A8] mb-6">
              Une erreur inattendue s'est produite. Essayez de recharger la page.
            </p>
            <div className="flex gap-3 justify-center">
              <Button
                onClick={this.handleReset}
                className="bg-[#C9A84C] text-[#060606] hover:bg-[#E2C56A]"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Réessayer
              </Button>
              <Button
                variant="outline"
                onClick={() => window.location.href = '/'}
                className="border-white/20 text-[#F5F0E8] hover:bg-white/5"
              >
                Retour à l'accueil
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
